<template>
  <div style="padding: 0px; margin: 0px" class="container">
    <el-header
      :style="{
        height: screenWidth >= 600 ? '64px' : hei ? hei : '56px',
        background: '#23262A',
        color: hei ? 'red' : 'white',
      }"
      class="position_top"
      v-if="show"
    >
      <div
        class="header"
        :style="{
          height: screenWidth >= 600 ? '64px' : '64px',
          justifyContent: screenWidth >= 600 ? 'space-between' : 'space-between',
          width: screenWidth > 1024 ? '1200px' : '',
          margin: screenWidth >= 600 ? 'auto' : '',
          padding: screenWidth >= 600 ? 'none' : '0 20px',
        }"
      >
        <div
          :style="{
            lineHeight: screenWidth >= 600 ? '64px' : '55px',
            alignItems: 'center',
          }"
        >
          <img
            :style="{
              marginTop: screenWidth >= 600 ? ' 4%' : '0%',
              height: screenWidth >= 600 ? ' 36px' : '30px',
              width: screenWidth >= 600 ? ' 90px' : '',
            }"
            src="@/assets/logo.png"
            alt="辰鳗科技集团-全球优秀的综合能源服务商"
          />
        </div>
        <div style="z-index: 1000">
          <ul class="myMune" v-if="screenWidth >= 600">
            <div
              v-for="(item, index) in navItems"
              :key="index"
              @click="active(index, item.path)"
              class="myMunediv"
            >
              <div class="myMunediv">
                <div
                  class="myMunediv"
                  :style="{ color: activeIndex == index ? '#3170FF' : '' }"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </ul>
          <div v-else @click="showPhone" class="phoneMenu">
            <div>
              <img :style="{ height: '15px' }" src="@/assets/menu.png" />
            </div>
          </div>
          <el-drawer
            :visible.sync="drawer"
            direction="rtl"
            size="100%"
            :append-to-body="true"
          >
            <template slot="title">
              <div>
                <img
                  :style="{ height: '30px' }"
                  src="@/assets/logo.png"
                  alt="辰鳗科技集团-全球优秀的综合能源服务商"
                />
              </div>
            </template>
            <div class="menuInfo">
              <div
                v-for="(item, index) in phoneNavItems"
                :key="index + 'ts'"
                @click="topage(index)"
              >
                {{ item.name }}
              </div>
              <div class="slogan" style="border: none">
                <img :style="{ height: '66px' }" src="@/assets/slogan.png" />
              </div>
            </div>
          </el-drawer>
        </div>
      </div>
    </el-header>
    <el-main id="main" class="main" style="padding: 0px; overflow: auto" ref="main">
      <div v-if="screenWidth > 600">
        <div class="section">
          <div class="swiper mySwiper111">
            <div class="swiper-wrapper">
              <div class="swiper-slide fadeInUp">
                <div class="section bannerClass">
                  <div class="title_wrap">
                    <div
                      :class="{
                        animate__animated: true,
                        hide: curPage !== 0,
                        animate__zoomIn: curPage === 0,
                      }"
                    >
                      <div class="title">小鳗管家</div>
                      <img src="../../assets/line.png" alt class="title_line" />
                      <div class="subtitle">SMALLEEL PLATFORM</div>
                      <div class="wrod">
                        小鳗管家能源管理系统利用物联网技术、移动互联网、大数据等技术，打通智能计量监测设备、数据采集器、云主机三者间的数据收发通道，形成高效的能耗物联网生态。满足商业建筑在配电监控、用电安全、能耗监测、新能源监控、碳排放监测等方面的需求，为客户搭建一套数字化的能源管控平台，实现绿色节能和高效运行管理。
                      </div>
                      <div
                        style="margin-top: 59px; font-family: 'Light'"
                        class="banner_btn"
                        @click="toProduct"
                      >
                        了解更多
                      </div>
                    </div>
                    <div class="model_wrap">
                      <img src="../../assets/Modle.png" class="model" alt />
                    </div>
                  </div>
                </div>
              </div>

              <div class="swiper-slide">
                <div class="section content">
                  <div class="contentTitle">
                    热门资讯
                    <div class="little_title">
                      <img src="../../assets/rect.png" alt />
                      POPULAR NEWS
                    </div>
                  </div>
                  <div class="news_content">
                    <div
                      class="hotItem news_item"
                      v-if="three[0]"
                      @click="toDetailother(three[0].aid, three[0].type)"
                    >
                      <img
                        :src="'https://file.smalleel.com/' + three[0].coverUrl"
                        alt
                        class="hotItem_img1"
                      />
                      <div
                        class="hotItem_title"
                        :class="{
                          animate__animated: true,
                          animate__zoomIn: curPage === 1,
                          hide: curPage !== 1,
                        }"
                      >
                        <p>{{ three[0].title }}</p>
                        <p class="p2" v-html="three[0].content"></p>
                      </div>
                    </div>
                    <div class="news_item">
                      <div
                        class="hotItem"
                        v-if="three[1]"
                        @click="toDetailother(three[1].aid, three[1].type)"
                      >
                        <img
                          :src="'https://file.smalleel.com/' + three[1].coverUrl"
                          alt
                          class="two_samll"
                        />
                        <div
                          class="hotItem_title"
                          :class="{
                            animate__animated: true,
                            animate__zoomIn: curPage == 1,
                            hide: curPage !== 1,
                          }"
                        >
                          <p>{{ three[1].title }}</p>
                          <p class="p2" v-html="three[1].content"></p>
                        </div>
                      </div>
                      <div
                        class="hotItem"
                        v-if="three[2]"
                        @click="toDetailother(three[2].aid, three[2].type)"
                      >
                        <img
                          :src="'https://file.smalleel.com/' + three[2].coverUrl"
                          alt
                          class="two_samll"
                        />
                        <div
                          class="hotItem_title"
                          :class="{
                            animate__animated: true,
                            animate__zoomIn: curPage == 1,
                            hide: curPage !== 1,
                          }"
                        >
                          <p>{{ three[2].title }}</p>
                          <p class="p2" v-html="three[2].content"></p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="footer">
                    <div class="more" @click="getMore(1)">查看更多 ></div>
                    <div class="footer-content">
                      <el-link
                        href="https://beian.mps.gov.cn/#/query/webSearch?recordcode=51019002004974"
                        target="_blank"
                        type="warning"
                        style="
                          color: #969fa6;
                          vertical-align: middle;
                          margin-right: 0.5rem;
                        "
                        >川公网安备51019002004974号</el-link
                      >
                      <el-link
                        href="https://beian.miit.gov.cn/#/Integrated/index"
                        target="_blank"
                        type="warning"
                        style="color: #969fa6; vertical-align: middle"
                        >copyright©2021-辰鳗科技集团有限公司-蜀ICP备2020027900号</el-link
                      >
                      <el-link
                        href="https://www.smalleel.com/sitemap.xml"
                        target="_blank"
                        type="warning"
                        style="color: #969fa6; vertical-align: middle"
                        >网站地址</el-link
                      >
                      <a
                        @click.prevent="goLegal('/privacy')"
                        href="/privacy"
                        style="
                          color: #969fa6;
                          vertical-align: middle;
                          cursor: pointer;
                          margin: 0 0.5rem;
                          text-decoration: none;
                        "
                        >隐私政策</a
                      >
                      <a
                        @click.prevent="goLegal('/copyright')"
                        href="/copyright"
                        style="
                          color: #969fa6;
                          vertical-align: middle;
                          cursor: pointer;
                          margin: 0 0.5rem;
                          text-decoration: none;
                        "
                        >版权声明</a
                      >
                      <a
                        @click.prevent="goLegal('/license')"
                        href="/license"
                        style="
                          color: #969fa6;
                          vertical-align: middle;
                          cursor: pointer;
                          margin: 0 0.5rem;
                          text-decoration: none;
                        "
                        >企业资质</a
                      >
                      <!-- <a
                        @click.prevent="goLegal('/faq')"
                        href="/faq"
                        style="
                          color: #969fa6;
                          vertical-align: middle;
                          cursor: pointer;
                          margin: 0 0.5rem;
                          text-decoration: none;
                        "
                        >常见问题</a
                      > -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="swiper-scrollbar"></div>
          </div>
        </div>
      </div>
      <div class="phonePage" v-else>
        <phone-home />
      </div>
    </el-main>
  </div>
</template>

<script>
//手机版首页
import phoneHome from "./phone/phoneHome.vue";
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
import { EventBus } from "../../untils/eventBus";
export default {
  components: {
    phoneHome,
  },
  name: "home",
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          //console.log(this.screenWidth);
          this.timer = false;
        }, 400);
      }
    },
  },
  data() {
    return {
      drawer: false,
      hei: 0,

      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0, // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      startTime: undefined, // 记录触摸开始的时间
      startX: undefined, // 记录触摸开始的X坐标，本次主要实现的是上下滑动，所以当前坐标不做强制要求
      startY: undefined,
      screenWidth: document.body.clientWidth,

      three: [],
      bannerHeight: 600,
      characteristic: [{ coverUrl: "" }],
      currentItemContent: {},
      other: [],
      curPage: 0,
      navItems: [
        { name: "首页", index: "0", path: "/" },
        { name: "产品中心", index: "1", path: "/product" },
        { name: "解决方案", index: "2", path: "/service" },
        { name: "资讯动态", index: "3", path: "/news" },
        { name: "走进辰鳗", index: "4", path: "/aboutUs" },
        { name: "加入辰鳗", index: "5", path: "/joinUs" },
        { name: "资料下载", index: "6", path: "/datas" },
      ],
      phoneNavItems: [
        { name: "首页" },
        { name: "产品中心" },
        { name: "解决方案" },
        { name: "资讯动态" },
        { name: "走进辰鳗" },
        { name: "加入辰鳗" },
      ],
      show: true,
      activeIndex: 0,
    };
  },
  mounted() {
    this.changeItem(1);
    this.getNew();
    this.injectOrganizationJsonLd();
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };

    this.initSwiper();

    window.scrollTo(0, 0);
  },
  methods: {
    injectOrganizationJsonLd() {
      const data = {
        "@context": "https://schema.org",
        "@type": ["Organization", "LocalBusiness"],
        "@id": "https://www.smalleel.com/#corporate",
        name: "辰鳗科技集团有限公司",
        alternateName: "小鳗管家 SMALLEEL PLATFORM",
        description:
          "辰鳗科技是综合能源数字化服务商，旗下小鳗管家平台面向商业综合体、写字楼、产业园区提供能源管理系统、计量收费系统、暖通空调节能算法系统、动力储能回馈系统、智慧照明系统、虚拟电厂运营管理系统等产品和解决方案。",
        url: "https://www.smalleel.com/",
        logo: "https://www.smalleel.com/static/logo.png",
        image: "https://www.smalleel.com/static/logo.png",
        foundingDate: "2020-01-01",
        founder: {
          "@type": "Person",
          name: "朱越洋",
        },
        address: {
          "@type": "PostalAddress",
          addressCountry: "CN",
          addressRegion: "四川省",
          addressLocality: "成都市",
          streetAddress: "双流区电子科大科技园B12栋四单元4F-6F",
        },
        contactPoint: [
          {
            "@type": "ContactPoint",
            telephone: "+86-28-86533354",
            contactType: "customer service",
            email: "xiaomanguanjia@smalleel.com",
            areaServed: "CN",
            availableLanguage: ["zh-Hans"],
          },
        ],
        sameAs: [
          "https://baike.baidu.com/item/%E8%BE%B0%E9%B3%9E%E7%A7%91%E6%8A%80%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/65769730",
        ],
      };
      let script = document.getElementById("jsonld-organization");
      if (script) script.remove();
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "jsonld-organization";
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
    },
    showPhone() {
      this.drawer = true;
      // this.phoneMune = !this.phoneMune
    },
    // GEO 整改 - 法律/FAQ链接 SPA 跳转
    goLegal(path) {
      if (path === "/license") {
        window.open("https://file.smalleel.com/2026/08/27/1787801883czyQb.jpg");
      } else {
        this.$router.push(path);
      }
    },
    topage(e) {
      switch (e) {
        case 0:
          this.$router.push({ path: "/" });
          break;
        case 1:
          this.$router.push({ path: "/phoneProduct" });
          break;
        case 2:
          this.$router.push({ path: "/phoneService" });
          break;
        case 3:
          this.$router.push({ path: "/phoneNews" });
          break;
        case 4:
          this.$router.push({ path: "/phoneCloseCM" });
          break;
        case 5:
          this.$router.push({ path: "/phoneJoinUs" });
          break;
        default:
          break;
      }
      this.drawer = false;
    },
    initSwiper() {
      let that = this;
      var swiper = new Swiper(".mySwiper111", {
        direction: "vertical",
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        crossFade: true,
        slidesPerView: 0,
        observeParents: true,
        initialSlide: 0,
        speed: 1000,
        mousewheel: {
          thresholdTime: 2000,
          thresholdDelta: 120,
        },
        forceToAxis: true,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
        preventClicks: false,
        preventClicksPropagation: false,
        on: {
          slideChangeTransitionEnd() {
            that.curPage = this.activeIndex;
          },
        },
      });
    },
    getMore(type) {
      this.$router.push({
        name: "more",
        params: {
          type: type,
        },
      });
    },
    active(index, path) {
      this.activeIndex = index;
      this.$router.push({ path: path });
    },
    toDetailother(id, type) {
      this.$router.push({
        path: "/newDetail/" + type + "_" + id + ".html",
      });
    },
    toProduct() {
      this.$router.push("/product2");
      EventBus.$emit("index", 1);
    },
    next() {
      // 往下切换
      let len = 2; // 页面的个数
      if (this.fullpage.current + 1 <= len) {
        // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
        this.fullpage.current += 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    pre() {
      // 往上切换
      if (this.fullpage.current - 1 > 0) {
        // 如果当前页面编号-1 大于0，则可以执行向下滑动
        this.fullpage.current -= 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    move(index) {
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      setTimeout(() => {
        //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
        this.fullpage.isScrolling = false;
      }, 1010);
    },
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      scrollHeight = -(index - 1) * height + "px";
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    mouseWheelHandle(event) {
      // 监听鼠标监听
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) {
        // 判断是否可以滚动
        return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0) {
        this.next();
      } else if (this.fullpage.deltaY < 0) {
        this.pre();
      }
    },

    // 清除触摸事件
    handleTouchmove(event) {
      event.preventDefault();
    },
    //手指按下屏幕
    handleTouchstart(event) {
      this.startTime = Date.now();
      this.startX = event.changedTouches[0].clientX;
      this.startY = event.changedTouches[0].clientY;
    },
    //手指离开屏幕
    handleTouchend(event) {
      const endTime = Date.now();
      const endX = event.changedTouches[0].clientX;
      const endY = event.changedTouches[0].clientY;
      //判断按下的时长
      if (endTime - this.startTime > 2000) {
        return;
      }
      //滑动的方向
      let direction = "";
      //先判断用户滑动的距离，是否合法，合法:判断滑动的方向 注意 距离要加上绝对值
      if (Math.abs(endY - this.startY) > 10) {
        //滑动方向
        direction = endY - this.startY > 0 ? "down" : "up";

        console.log(direction, "dir");
      } else {
        return;
      }
      //用户做了合法的滑动操作
      // console.log('方向'+direction)
      if (direction === "up") {
        this.next();
      }
      if (direction === "down") {
        this.pre();
      }
    },

    getNew() {
      var params = new URLSearchParams();
      params.append("start", 1);
      params.append("limit", 3);
      // params.append('position', 1);
      this.$axios.post("/api/websiteNews/websiteList", params).then(res => {
        let list = JSON.parse(JSON.stringify(res.data.data.records));
        // this.characteristic = JSON.parse(JSON.stringify(res.data.data.records))
        // list.splice(0,1)
        this.three = list;
      });
    },
    goPath(index) {
      if (index == 0) {
        this.$router.push("/product");
        document.getElementById("main").scrollTop = 600;
      } else if (index == 1) {
        this.$router.push("/product");
        document.getElementById("main").scrollTop = 1500;
      } else if (index == 2) {
        this.$router.push({
          path: "/aboutUs",
          query: {
            to: 1,
          },
        });
        document.getElementById("main").scrollTop = 1400;
      }
    },
    changeItem(id, index) {
      let _this = this;
      if (index) {
        this.other.forEach(function (item) {
          if (item.aid == id) {
            console.log(item);
            _this.$router.push({
              name: "newDetail",
              params: {
                to: JSON.stringify(item),
              },
            });
          } else {
            item.active = 0;
          }
        });
      } else {
        this.characteristic.forEach(function (item) {
          if (item.aid == id) {
            console.log(item);
            _this.$router.push({
              name: "newDetail",
              params: {
                to: JSON.stringify(item),
              },
            });
          } else {
            item.active = 0;
          }
        });
      }
    },

    changeClick(direction) {
      let isSelectNew = false;
      if (direction == -1) {
        let tempId = -1;
        for (let i = 0; i < this.characteristic.length; i++) {
          let item = this.characteristic[i];
          if (tempId > 0) {
            this.changeItem(item.id);
            isSelectNew = true;
            return;
          }
          if (item.active == 1 && tempId == -1) {
            tempId = item.id;
            item.active = 0;
          }
        }
        if (!isSelectNew) {
          this.changeItem(this.characteristic[0].id);
        }
      } else if (direction == 1) {
        let tempId = -1;
        for (let i = this.characteristic.length - 1; i >= 0; i--) {
          let item = this.characteristic[i];
          if (tempId > 0) {
            this.changeItem(item.id);
            isSelectNew = true;
            return;
          }
          if (item.active == 1 && tempId == -1) {
            tempId = item.id;
            item.active = 0;
          }
        }
        if (!isSelectNew) {
          this.changeItem(this.characteristic[this.characteristic.length - 1].id);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/style/home.scss";
.myMune {
  color: #fff;
  position: relative;
  margin: 0;
  padding-left: 0;
  cursor: pointer;
  font-size: 14px;
}
.myMunediv {
  list-style: none;
  float: left;
  width: 150px;
  height: 64px;
  font-size: 16px;
  line-height: 64px;
  text-align: center;
  margin: 0;
}

.phoneMenu {
  margin-top: 20px;
}
.menuInfo div {
  height: 53px;
  border-bottom: 1px solid #e3e7ea;
  margin: 10px;
  line-height: 53px;
  padding: 0 8px;
  font-family: Source Han Sans CN;
  color: #353639;
  font-size: 16px;
  font-family: "Regular";
}
.slogan {
  position: absolute;
  bottom: 4%;
  left: 0%;
  border: none;
}

.container {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.el-header {
  /* background-color: #5152E1; */
  height: 70px;
  width: 100%;
  margin: 0px;
  padding: 0px;
  z-index: 100;
}

.header {
  display: flex;
  /* justify-content: space-around; */
  /* align-items: center; */
}

.el-menu--horizontal > .el-menu-item {
  float: right;
  width: 150px;
  height: 70px;
  font-size: 20px;
  line-height: 70px;
  text-align: center;
  margin: 0;
  /* border-bottom: 2px solid transparent; */
  color: #ffffff;
}

.el-menu.el-menu--horizontal {
  background-color: transparent;
  border-bottom: solid 0px #5152e1;
  color: #ffffff;
}

.el-menu.el-menu--horizontal:hover {
  background-color: transparent;
  border-bottom: solid 0px #5152e1;
  color: #ffffff;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
  background: rgb(224, 156, 9);
  color: #ffffff;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px solid transparent;
  color: #ffffff;
  background: rgb(224, 156, 9);
}

.bannerClass {
  width: 100%;
  color: #ffffff;
  background-image: url("https://file.smalleel.com/2023/08/28/16931867041GIT1.png");
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
}
.innertext {
  color: #fff;
  font-size: 48px;
  font-weight: initial;
  margin-top: 36px;
  letter-spacing: 5px;
  line-height: 100px;
}
.contentItemPane {
  padding-top: 30px;
  width: 100%;
  height: 469px;
  background: url("../../assets/md.png") 0 0 no-repeat;
}
.flex_title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.left {
  height: 630px;
  margin: auto;
}
.top_name {
  font-size: 30px;
  background-image: url("../../assets/title.png");
  background-size: 100%;
  letter-spacing: 2px;
  padding: 30px 0;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_img {
  background: url("../../assets/titlebom.png");
  background-size: 100%;
  height: 120px;
}
.border {
  margin-top: 20px;
  width: 30px;
  height: 3px;
  background: white;
}
.right {
  text-align: left;
  min-height: 400px;
  padding: 0px 20px;
}

.clickImg {
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.characteristicItem {
  border: 1px solid #eeeeee;
  margin: 8px 0;
  padding: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.characteristicItemActive {
  margin: 8px 0;
  padding: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  /* background-color: #1746aa; */
  border: 1px solid #eeeeee;
  /* color: #ffffff; */
}

.currentItemContent {
  background-color: #f2f2f2;
  width: 720px;
  min-height: 80px;
  margin-top: -190px;
  margin-left: 25px;
  padding: 200px 20px 40px 20px;
}

.currentItemContentTitle {
  display: flex;
  color: #080000;
  font-size: 24px;
  line-height: 36px;
}

.currentItemContentTitleEn {
  display: flex;
  color: #080000;
  font-size: 22px;
  line-height: 36px;
}

.currentItemContentLine {
  width: 40px;
  height: 3px;
  background-color: #606060;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
}

.currentItemContentContent {
  color: #000000;
  font-size: 16px;
  text-align: left;
  line-height: 30px;
}

.characteristicItemImg {
  width: 40px;
  height: 40px;
}

.characteristicItemImg img {
  height: 100%;
}

.characteristicItemTxt {
  font-size: 20px;
  text-align: center;
  vertical-align: middle;
  flex: 1;
}

.productType {
  text-align: center;
  height: 380px;
  width: 33%;
  position: relative;
}

.productTypeInfo {
  width: 100%;
  bottom: 46%;
  letter-spacing: 3px;
  font-size: 32px;
  position: absolute;
  color: #fff;
}

/* .productType:hover {
  box-shadow: 10px 10px 10px #eeeeee;
}

.productType:hover .productTypeInfo {
  bottom: 60px;
} */

.productTypeContent {
  display: none;
  color: #999999;
  font-size: 14px;
}

.productType:hover .productTypeContent {
  display: inherit;
}

.productTypeImg {
  width: 92%;
  height: 235px;
  margin-top: 70px;
}

/* .productType:hover .productTypeImg {
  width: 228px;
  height: 258px;
  margin-top: 20px;
} */
hotItem_img1 .productTypeTitle {
  color: #fff;
  font-size: 20px;
  margin-bottom: 20px;
}

.proContent {
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
}

.proContent:hover {
  color: #f8a111;
}

.proContent:hover .proContent2 {
  color: #f8a111;
  opacity: 1;
}

.proContent1 {
  margin-top: 20px;
}

.proContent2 {
  margin-top: 10px;
  opacity: 0.4;
}

.img1 {
  width: 134px;
  height: 155px;
}

.showImg {
  width: 40px;
  height: 40px;
}

.proContent:hover .img1 {
  width: 0px;
  height: 0px;
}

.img2 {
  width: 0px;
  height: 0px;
}

.proContent:hover .img2 {
  width: 134px;
  height: 155px;
}
.banner_btn {
  width: 120px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: rgba(0, 0, 0, 0);
  border: 1px solid #3170ff;
  border-radius: 16px;
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  color: #3170ff;
  cursor: pointer;
}
.model {
  width: 736px;
  height: 560px;
}
.little_title {
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  color: #34383b;
  margin-top: 13px;
  img {
    width: 14px;
    height: 14px;
  }
}
.content {
  width: 100%;
  background: url("https://file.smalleel.com/2023/08/28/1693186844mUmjm.png") 0 0
    no-repeat;
  background-position: center;
  background-size: cover;
}
.hotItem {
  position: relative;
}

.info_item {
  width: 100%;
  height: 100%;
  position: relative;
}
.info_item::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.3);
}
.hotItem_title {
  cursor: pointer;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 0 24px;
  background: linear-gradient(rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.6)) 90%;
  p {
    font-family: "Medium";
    font-weight: 500;
    color: #ffffff;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: break-word;
    word-break: break-all;
    /* width: 500px; */
    margin: 0;
    padding: 0;
    margin-bottom: 15px;
  }

  .p2 {
    /* width: 500px; */
    font-size: 14px;
    font-family: "Light";
    font-weight: 300;
    color: #ffffff !important;
    line-height: 20px;
    height: 28px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    p {
      span {
        color: #fff !important;
      }
    }
  }
}

.footer {
  width: 1200px;
  margin: auto;
  margin-top: 20px;
  .more {
    font-size: 14px;
    font-family: "Regular";
    font-weight: 400;
    color: #3170ff;
    text-align: left;
    cursor: pointer;
  }
  .footer-content {
    margin-top: 80px;
    font-size: 12px;
    font-family: "Regular";
    font-weight: 400;
  }
}

.contentTitle {
  padding-top: 90px;
  font-size: 36px;
  letter-spacing: 2px;
}

.title_wrap {
  text-align: left;
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.title {
  color: #ffffff;
  font-size: 60px;
  font-weight: initial;
  font-family: "PangMenZhengDao";
  letter-spacing: 6px;
  margin-top: 60px;
}
.hotItem_img1 {
  width: 662px;
  height: 500px;
  object-fit: cover;
  flex: 1;
  position: relative;
}
.hotItem_img1::after {
  position: absolute;
  width: 100%;
  height: 100%;
  content: "";
  background: linear-gradient(rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.6)) 90%;
}
.two_samll {
  width: 540px;
  height: 250px;
  object-fit: cover;
  flex: 1;
}
.two_samll::before {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}
.news_content {
  margin-left: 24px;
  margin-right: 24px;
  display: flex;
  justify-content: center;
  margin-top: 70px;
}
.phonePage {
  height: 100vh !important;
}
.title_line {
  width: 240px;
  height: 8px;
  margin-top: 16px;
}
.subtitle {
  color: #ffffff;
  font-size: 24px;
  font-weight: initial;
  margin-top: 20px;
  font-family: "Regular";
}
.wrod {
  color: #ffffff;
  font-size: 14px;
  font-weight: initial;
  margin-top: 59px;
  width: 320px;
  font-family: "Light";
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/home.vue